import Icon from "@/components/Icon"
import { type FormSection } from "@/models"
import { css } from "vite-css-in-js"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	section: FormSection
}

const sectionStyles = css`
	padding: 1.25rem;
	padding-top: 0;
	padding-bottom: 2rem;

	& > h5 {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		font-size: 1.125rem;
		padding-top: 1.25rem;
	}
`

const MarriageClaimFormSection: ReactiveComponent<Props> = (props) => {
	return () => (
		<section class={sectionStyles} style={{ backgroundColor: props.section.color }}>
			<h5 id={props.section.id}>
				<Icon icon={props.section.icon} />
				<span>{props.section.name}</span>
			</h5>
			<hr class="my-2" />
			{props.section.render && <props.section.render />}
		</section>
	)
}

export default defineComponent(MarriageClaimFormSection, inferProps<Props>())
